<template>
  <v-row class="price-list">
    <v-expansion-panels
      accordion
      v-model="servicePriceListPanel"
    >
      <v-expansion-panel
        v-for="(price, index) in prices"
        :key="index"
        class="price-list__v-panel"
      >
        <v-expansion-panel-header class="price-list__item">
          <div class="price-list__item__title">{{price.name}}</div>
          <div class="price-list__item__controls">
            <button
              class="price-list__icon-edit"
              type="button"
              v-on:click.stop="onEditServicePriceList(price.id)"
            />
            <button
              class="price-list__icon-delete"
              type="button"
              v-on:click.stop="onDeletePriceList(price.id)"
            />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content
          class="price-list__content"
          v-bind:class="{ 'is-modile': isMobile }"
        >
          <category-item
            style="width: 270px"
            v-for="category in price.serviceCategories"
            v-bind:is-drag="true"
            v-bind:category="category"
            v-bind:has-delete="hasDelete"
            v-bind:has-edit="hasEdit"
            v-bind:key="category.id"
            v-bind:selected-category=selectedCategory
            v-bind:drag-selected-element="dragSelectedElement"
            v-on:set-drag-select="onSetDragSelectedElement"
            v-on:delete-category="onOpenDialogConfirmDeleteCategory"
            v-on:edit-category="onOpenEditForm"
            v-on:select-category="onSelectCategory"
            v-on:change-order-categories="onChangeOrderCategory"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script>
import CategoryItem from '@/components/CategoryItem.vue';
import mobileMixin from '@/mixins/mobileMixin';

/**
 * @description Событие открытие диалога подтверждения удаления категории.
 * @type {string}
 */
const ON_DELETE_CATEGORY = 'delete-category';

/**
 * @description Удалить прайс-лист.
 * @type {string}
 */
const ON_DELETE_PRICE_LIST = 'delete-price-list';

/**
 * @description Редактировать прайс-лист.
 * @type {string}
 */
const ON_EDIT_PRICE_LIST = 'edit-price-list';

/**
 * @description Событие открытия формы редактирования категории.
 * @type {string}
 */
const ON_EDIT_CATEGORY = 'edit-category';

/**
 * @description Событие наведения на элемент.
 * @type {string}
 */
const ON_SET_DRAG_SELECT = 'set-drag-select';

/**
 * @description Событие выбранная категория.
 * @type {string}
 */
const ON_SELECT_CATEGORY = 'select-category';

/**
 * @description Событие порядок категорий сменился.
 * @type {string}
 */
const ON_CHANGE_ORDER_CATEGORIES = 'change-order-categories';

export default {
  name: 'PriceList',
  components: { CategoryItem },
  mixins: [
    mobileMixin,
  ],
  data() {
    return {
      /**
       * @description Раскрытая панель прайс-листа.
       * @type {Number}
       */
      servicePriceListPanel: this.initServicePriceListPanel,
    };
  },
  created() {

  },
  methods: {
    /**
     * @description Обработать событие редактирования прайс-листа.
     *
     * @returns {void}
     */
    onEditServicePriceList(id) {
      return this.$emit(ON_EDIT_PRICE_LIST, id);
    },
    /**
     * @description Обработать событие удаления прайс-листа.
     *
     * @param id
     *
     * @returns {void}
     */
    onDeletePriceList(id) {
      this.$emit(ON_DELETE_PRICE_LIST, id);
    },
    /**
     * @description Отправить событие наведения на элемент
     * через "drag"
     * @param {HTMLElement|null} element Идентификатор категории.
     * @returns {void}
     */
    onSetDragSelectedElement(element) {
      this.$emit(ON_SET_DRAG_SELECT, element);
    },
    /**
     * @description Отправить событие открытия диалога подтверждающего удаление категории.
     * @param {number} categoryId Идентификатор категории.
     * @param {number|null} priceId Идентификатор Прайса.
     * @returns {void}
     */
    onOpenDialogConfirmDeleteCategory(categoryId, priceId) {
      this.$emit(ON_DELETE_CATEGORY, categoryId, priceId);
    },
    /**
     * @description Отправить событие открытие формы категории.
     * @param {number} categoryId Идентификатор категории.
     * @param {number|null} priceId Идентификатор Прайса.
     * @returns {void}
     */
    onOpenEditForm(categoryId, priceId = null) {
      this.$emit(ON_EDIT_CATEGORY, categoryId, priceId);
    },
    /**
     * @description Отправить событие открытие формы категории.
     * @param {number} categoryId Идентификатор категории.
     * @param {number|null} priceId Идентификатор Прайса.
     * @returns {void}
     */
    onSelectCategory(categoryId, priceId = null) {
      this.$emit(ON_SELECT_CATEGORY, categoryId, priceId);
    },
    /**
     * @description Отправить событие изменения порядка категории.
     * @param {object} data Идентификаторы категорий ("Выбранная", "Наведенная").
     * @returns {void}
     */
    onChangeOrderCategory(data) {
      this.$emit(ON_CHANGE_ORDER_CATEGORIES, data);
    },
  },
  props: {
    /**
     * @description Начальный номер раскрытой панель прайс-листа.
     * @type {Number}
     */
    initServicePriceListPanel: {
      type: Number,
      required: false,
      default: () => 0,
    },
    /**
     * Выбранный элемент методом drag
     * @type {boolean}
     */
    dragSelectedElement: {
      type: HTMLElement,
      required: false,
      default: () => {},
    },
    /**
     * @description Идентификатор выбранной категории.
     * @type {number|string}
     */
    selectedCategory: {
      type: [Number, String],
      required: true,
    },
    /**
     * @description Прайс категорий
     * @type Array<ServicePriceList>
     */
    prices: {
      type: Array,
      required: true,
    },
    /**
     * @description Имеет право удалять услуги.
     * @type {Boolean}
     */
    hasDelete: {
      type: Boolean,
      required: true,
    },
    /**
     * @description Имеет право редактировать услуги.
     * @type {Boolean}
     */
    hasEdit: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.price-list {
  text-align: left;
  &__icon {
    &-edit {
      align-self: center;
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-delete {
      align-self: center;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
  }
  &__item {
    background-color: #f2f7fa;
    display: grid;
    flex-direction: row;
    grid-template-columns: 75% 15% 10%;
    text-align: left;
    overflow-wrap: anywhere;
    hyphens: auto;
    &__controls {
      display: flex;
      gap: 10px;
    }
    &__title {
      flex: 1;
      cursor: pointer;
      font-size: 14px;
      line-height: 17px;
      &:hover {
        color: #0489e0;
      }
    }
  }
  &__content {
    background-color: #f2f7fa;
  }
  &__content:not(.is-modile) {
    ::v-deep .v-expansion-panel-content__wrap {
      padding-inline: 0;
    }
  }
  &__v-panel {
    &:before {
      box-shadow: none;
    }
  }
}

@media screen and (max-width: 1190px) {
  ::v-deep .v-expansion-panel-content__wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 20px;
    padding-inline: 24px;
  }
}
</style>
